<template>
    <div class="page-content header-clear-medium">

		<div v-if="loading">
			<AnnouncementSekeleton :count="3" />
		</div>
		<div v-else>
			<div v-for="announcement in announcements" :key="announcement.id" class="card card-style mt-5 overflow-visible" :class="{ 'idle-announcement' : !announcementsReadLocal.includes(parseInt(announcement.id)) }">
				<div class="mt-n4 mx-auto rounded-circle shadow-xl bg-blue-dark d-flex justify-content-center align-items-center" style="height: 50px; width: 50px;">
					<i class="bi bi-megaphone-fill font-25 d-block pb-1"></i>
				</div>
				<div class="content text-center">
					<div class="px-3 mb-n3">
						<h1 class="font-700">{{ announcement.title.rendered }}</h1>
						<div class="d-flex justify-content-between justify-content-md-center mb-3">
							<a href="javascript:void(0)" @click="readAnnouncement(announcement.id, announcement.link)" class="btn-full btn btn-xs border-blue-dark color-blue-dark bg-white">Selengkapnya</a>
							<!-- <a target="_blank" :href="`${announcement.link}`" class="btn-full btn btn-xs border-blue-dark color-blue-dark bg-white">Selengkapnya</a> -->
						</div>
					</div>
				</div>
			</div>

			<div v-show="nextPage <= announcements_total_pages" class="content">
				<a href="javascript:void(0)" @click="getDataAnnouncementsLoadMore(nextPage)" class="btn-full btn-s btn gradient-blue"><i class="bi bi-box-arrow-down pe-2 ms-n1"></i> Load More</a>
			</div>
		</div>
        
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'

import AnnouncementSekeleton from "../components/skeleton/AnnouncementSekeleton.vue";

export default {
    name: 'Announcement',
    components: {
		AnnouncementSekeleton
    },
    data() {
        return {
			nextPage : 2,
        }
    },
    async created() {
		this.SET_LOADING()
		await this.getAnnouncements()
		this.CLEAR_LOADING()
    },
    methods: {
        ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
		...mapActions('announcementWp', ['getAnnouncements', 'getAnnouncementsLoadMore']),
		...mapActions('notificationLocal', ['readAnnouncementNotificaion']),
		readAnnouncement(announcement_id, slug) {
			if (!this.announcementsReadLocal.includes(parseInt(announcement_id))) {
				this.readAnnouncementNotificaion(announcement_id)
			}
			window.open(slug);
			// this.$router.push({name: 'announcement.detail', params: { slug: slug }})
		},
		async getDataAnnouncementsLoadMore(nextPage) {
			await this.getAnnouncementsLoadMore(nextPage)
			this.nextPage++
		}
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
        ...mapState('announcementWp', {
			announcements_total_pages: state => state.announcements_total_pages,
            announcements: state => state.announcements
        }),
		...mapState('notificationLocal', {
            announcementsReadLocal: state => state.announcementsReadLocal
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.idle-announcement {
	background-color: #B9D7FF !important; 
	color: #FFF !important;
}
</style>
